import { z } from "zod";

export const buildPatientInformationSchema = (/* t: (key: string, opts?: Record<string, string>) => string */) =>
  z.object({
    firstName: z
      .string()
      .trim(),
      //.min(1, { message: t("validation.firstNameRequired") })
    lastName: z
      .string()
      .trim(),
      //.min(1, { message: t("validation.lastNameRequired") }),
    birthDate: z
      .date({
        //required_error: t("validation.birthDateRequired"),
        //invalid_type_error: t("validation.birthDateInvalid"),
      }).optional(),
      /* .refine((date) => date <= new Date(), {
        message: t("validation.birthDate"),
      }), */
    phone: z
      .string()
      .trim()
      .optional(),
    address: z
      .string()
      .trim()
      .optional(),
    email: z
      .string()
      .trim()
      .optional(),
    identificationNumber: z.string().refine(
      (val) => {
        if (val === "") return true;
        if (val.length !== 13) return false;
        return /^[A-Za-z0-9]+$/.test(val);
      },
      {
        //message: t("validation.identificationNumber"),
      },
    ),
  });